import { KeyLike, importSPKI, jwtVerify } from 'jose';
import IToken from '@/Auth/IToken';

interface IJwtHeaderToken {
    kid: string;
}

export async function verifyToken(token: string): Promise<IToken> {
    const [ headerEncoded ] = token.split('.');
    const buf: Buffer = Buffer.from(headerEncoded, 'base64');

    const decodedJwtHeader: IJwtHeaderToken = JSON.parse(buf.toString());

    if (decodedJwtHeader.kid === process.env.JWT_KEY_ID) {
        const publicKey: KeyLike = await importSPKI(process.env.JWT_PUBLIC_KEY.replace(/\\n/g, '\n'), process.env.JWT_ALGORITHM);

        const { payload } = await jwtVerify<IToken>(token, publicKey, {
            algorithms: [ process.env.JWT_ALGORITHM ],
        });

        return payload;
    }

    if (process.env.JWT_KEY_ID_PREVIOUS && decodedJwtHeader.kid === process.env.JWT_KEY_ID_PREVIOUS) {
        const publicKey: KeyLike = await importSPKI(process.env.JWT_PUBLIC_KEY_PREVIOUS.replace(/\\n/g, '\n'), process.env.JWT_ALGORITHM_PREVIOUS);
        const { payload } = await jwtVerify<IToken>(token, publicKey, {
            algorithms: [ process.env.JWT_ALGORITHM_PREVIOUS ],
        });

        return payload;
    }

    throw new Error(`Unknown JWT token key ID: ${decodedJwtHeader.kid}`);
}